import React from 'react';
import FeatureCard from './FeatureCard.tsx';
import { Calendar, Image, Clock, CreditCard, Map, ListTodo } from 'lucide-react';

const Features: React.FC = () => {
  const features = [
    {
      icon: Calendar,
      title: 'Smart Timeline',
      description: 'Automatically generate and manage your wedding planning timeline with customizable reminders.',
    },
    {
      icon: Image,
      title: 'AI Inspiration',
      description: 'Generate wedding theme and style ideas with our AI-powered image generation technology.',
    },
    {
      icon: Clock,
      title: 'Day-of Coordination',
      description: 'Your personal AI wedding assistant orchestrates every detail, coordinating with vendors and keeping your special day flowing perfectly.',
    },
    {
      icon: CreditCard,
      title: 'Budget Tracking',
      description: 'Master your wedding finances with our comprehensive budget management system. Track expenses, optimize spending, and stay on target.',
      meta: {
        features: [
          'Real-time budget tracking',
          'Category-wise spending analysis',
          'Payment schedule reminders',
          'Vendor payment tracking',
          'Budget optimization suggestions'
        ]
      }
    },
    {
      icon: Map,
      title: 'Vendor Discovery',
      description: 'Connect with the perfect wedding professionals for your special day. Browse, compare, and book with confidence.',
      meta: {
        features: [
          'Verified venue listings',
          'Professional photographers',
          'Expert florists & decorators',
          'Premium catering services',
          'Entertainment specialists'
        ]
      }
    },
    {
      icon: ListTodo,
      title: 'Taskboard',
      description: 'Plan like a pro with our Jira-style taskboard. Create, track, and organize every wedding planning task with customizable workflows.',
      meta: {
        features: [
          'Kanban-style task management',
          'Custom task statuses',
          'Priority levels',
          'Task dependencies',
          'Vendor collaboration'
        ]
      }
    }
  ];

  return (
    <section id="features" className="py-20 relative bg-white">
      {/* Removed the large absolute background div for a cleaner look */}
      
      <div className="container-custom relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-[44px] font-bold font-cormorant-garamond leading-[1.2] text-[#1C1C1E] mb-6">
            Everything You Need For Your <span className="italic text-[#FF4E8E]">Perfect Day</span>
          </h2>
          <p className="font-cormorant-garamond font-normal text-[16px] text-[#535353] max-w-[720px] mx-auto">
            Our comprehensive wedding planning platform offers all the tools you need to plan your wedding from start to finish, stress-free.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              meta={feature.meta}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;